import { SupabaseConnectionTest } from '@/components/SupabaseConnectionTest';

export default function DatabaseHealth() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Database Health</h1>
        <p className="text-gray-600">Monitor database connections and system health</p>
      </div>
      
      <SupabaseConnectionTest />
    </div>
  );
}
